import { effectivePower } from '../projectIntent';
import type { ProjectIntent } from '../../types/siteRag';
import { createRegistryResolver, tierSource } from './resolveCore';
import type { RegistryResolver, ResolverFactoryOptions } from './types';

export interface ProjectIntentResolverInput extends ResolverFactoryOptions {
  projectIntent?: ProjectIntent;
  siteContextMw?: number | null;
  llmInferredMw?: number | null;
}

export function createProjectIntentResolver(opts: ProjectIntentResolverInput): RegistryResolver {
  const intent = opts.projectIntent;
  const power = effectivePower(intent);
  const fieldSources: Record<string, ReturnType<typeof tierSource>[]> = {};

  if (power.mw != null) {
    fieldSources.powerRequirementMW = [
      tierSource(1, power.mw, {
        kind: 'manual',
        ref: 'intent:powerRequirementMW',
        label: 'User project intent',
      }),
    ];
  } else if (opts.siteContextMw != null) {
    fieldSources.powerRequirementMW = [
      tierSource(2, opts.siteContextMw, {
        kind: 'site-context',
        ref: 'siteContext:powerMW',
        label: 'Site context claim',
      }),
    ];
  } else if (opts.llmInferredMw != null) {
    fieldSources.powerRequirementMW = [
      tierSource(3, opts.llmInferredMw, {
        kind: 'llm-inference',
        ref: 'llm:powerMW',
        label: 'LLM inferred MW',
      }),
    ];
  }

  if (intent?.coolingStrategy) {
    fieldSources.coolingStrategy = [
      tierSource(1, intent.coolingStrategy, {
        kind: 'manual',
        ref: 'intent:coolingStrategy',
        label: 'User cooling choice',
      }),
    ];
  }

  if (intent?.inServiceDate) {
    fieldSources.inServiceDate = [
      tierSource(1, intent.inServiceDate, {
        kind: 'manual',
        ref: 'intent:inServiceDate',
        label: 'User COD target',
      }),
    ];
  }

  if (intent?.priority) {
    fieldSources.priority = [
      tierSource(1, intent.priority, {
        kind: 'manual',
        ref: 'intent:priority',
        label: 'User priority',
      }),
    ];
  }

  return createRegistryResolver({
    registryId: 'projectIntent',
    siteId: opts.siteId,
    fieldSources,
    now: opts.now,
  });
}
